export const formatLocation = (
  country?: string | null,
  city?: string | null,
) => {
  return city && country
    ? [city.toUpperCase(), country.toUpperCase()].join(' — ')
    : '';
};
